<template>
  <v-container fluid>
    <div v-if="order">
    <v-card class="mb-10" dense>
      <v-card-title>Order #{{order.id}}  ({{order.status}})
        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-cash-usd</v-icon>
          </v-btn>
          </template>
          <span>Send Invoice</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-receipt</v-icon>
          </v-btn>
          </template>
          <span>Send Payment Receipt</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-email-send</v-icon>
          </v-btn>
          </template>
          <span>Send Welcome Email</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
         Order submitted on {{order.updatedAt | formatDateTimes}}
          </v-col>
          <v-col>
            Paid {{order.actualPaid | currency}}
          </v-col>
          <v-col>
            Transaction ID {{order.transactionId || 'N/A'}}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Customer</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
        {{rp.firstName}} {{rp.lastName}}
          </v-col>
          <v-col>
        {{rp.email}}
          </v-col>
          <v-col>
        {{rp.phone}}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title>Students</v-card-title>
      <v-card-text>
        <div v-for="student in students" :key="student.id">
          <v-row>
            <v-col>
              {{student.firstName}} {{student.lastName}}
            </v-col>
            <v-col>
             {{student.relationship}}
            </v-col>
            <v-col>
             Grade {{student.grade}}
            </v-col>
            <v-col>
              {{student.email}}
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title>Courses</v-card-title>
      <v-card-text>
        <div v-for="cr in courseRegistrations" :key="cr.id">
          <v-row>
            <v-col cols="12">
              {{cr.course.name}} (
                <span v-if="cr.course.subject == 'Camp'">{{cr.course.pricePerWeek | currency}} per week</span>
                <span v-else>{{cr.course.pricePerSession | currency}} per session</span>
                )
            </v-col>
            <v-col>
              {{cr.students.firstName}} {{cr.students.lastName}}
            </v-col>
            <v-col>
              Schedule {{cr.course.scheduleStart | formatDateTimes}} ~
              {{cr.course.scheduleEnd | formatDateTimes}}
            </v-col>
            <v-col cols="12">
             {{cr.course.description}}
            </v-col>
            <v-col cols="12">
              Weeks:
              <div v-for=" (plan, index) in course2Weeks[cr.id].schedulePlan" :key="plan.week">
                Week {{index+1}} ({{plan.dates.map(d => d.format('MMM DD')).join(', ')}})
              </div>
            </v-col>
            <v-col cols="12">
              <hr/>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import * as scheduleUtils from "@/components/course/schedule.js";

export default {
  data() {
    return {
      order: null,
      rp: null,
      courseRegistrations: [],
      students: [],
      course2Weeks: {}
    };
  },
  filters: {
    formatDateTimes(value){
      return moment(value).format('ddd, MMM DD YYYY hh:mm a')
    }
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  watch: {
    
  },
  methods: {
    ...mapActions(["showDialog", "hideDialog", "addErrorMessage"]),
    async initOrder() {
      const result = await this.$axios
        .get("/order/getOrderById", {
          params: { orderId: this.$route.params.id }
        })
        .then(resp => {
          this.loading = false;
          console.log(resp.data)
          this.order = resp.data.data;
          this.rp = this.order.rp;
          this.courseRegistrations = this.order['orders.courseRegistration'];
          
          this.students = [];
          this.courseRegistrations.forEach( cr => {
            const student = cr.students;
            console.log(student)
            const exist = this.students.find( s => s.id == student.id);
            if(!exist){
              this.students.push(student);
            }

            const scheduledDates = cr['courseRegistration_courseRegistrationSchedules'].map(cs => cs.courseSchedule.start);
            // const scheduledDates = courseSchedules.map(cs => cs.start);
            // console.log("grouping schedule dates to weeks");
            const weekGroups = scheduleUtils.groupSchedulesByWeeks(scheduledDates);
            this.course2Weeks[cr.id] = weekGroups;
          })


          console.log(this.course2Weeks)
          // this.courses = courseRegistrations.map(cr => cr.course);

        })
        .catch(() => {
          this.addErrorMessage("Error loading order from server");
        });

      return result;
    },
  },
  created() {
    this.initOrder();
  }
};
</script>

<style>
</style>